module.exports = __webpack_public_path__ + "static/media/TonoDaruma_02A.bc5b72f9.gif";